export default [
  {
    path: '/admin/pos/restaurant-orders',
    name: 'restaurant-order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/restaurant-order/index.vue')
  },
  {
    path: '/admin/pos/counter-checkouts-orders',
    name: 'counter-checkout-order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/restaurant-order/counter-checkout.vue')
  }
]
